<template>
    <v-container grid-list-xl fluid>
        <v-layout row wrap>
            <v-flex lg12>
                <v-card>
                    <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter"
                        v-on:quickFilter="quickFilter"></hpo-filter>
                    <v-data-table :headers="headers" :items="items" :options.sync="pagination"
                        :server-items-length="total_rows" :footer-props="items_per_page" :must-sort="true"
                        :loading="loading" :mobile-breakpoint="100">
                        <template v-slot:item="{ item }">
                            <tr :id="'r-' + item.id">
                                <td class="images" v-viewer="options">
                                    <img style="height: 120px;" :src="item.images[0].path"
                                        v-if="item.images.length > 0" />
                                    <img style="height: 120px;" :src="item.images[1].path"
                                        v-if="item.images.length > 1" />
                                    <img style="height: 120px;" :src="item.images[2].path"
                                        v-if="item.images.length > 2" />
                                    <img style="height: 120px;" :src="item.images[3].path"
                                        v-if="item.images.length > 3" />
                                    <img style="height: 120px;" :src="item.images[4].path"
                                        v-if="item.images.length > 4" />
                                    <img style="height: 120px;" :src="item.images[5].path"
                                        v-if="item.images.length > 5" />
                                </td>
                                <td>{{ item.product_code }}</td>
                                <td><v-chip v-if="item.status" :color="display_value_background_color(item.status, statusOptions)" :text-color="display_value_color(item.status, statusOptions)" variant="flat">{{ item.status | display_value(statusOptions) }}</v-chip></td>
                                <td>{{ item.madein }}</td>
                                <td>{{ item.note }}</td>
                                <td>{{ item.propertices }}</td>
                                <td>{{ item.staff_name }}</td>
                                <td>{{ item.created_date | display_date }}</td>
                                <td class="text-center">
                                    <v-icon v-if="is_admin" medium class="mr-2"
                                        @click="gotoDetail(item.id)">edit</v-icon>
                                    <v-icon v-if="is_admin" medium @click="deleteItem(item.id)">delete</v-icon>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </v-flex>
        </v-layout>
        <v-dialog v-model="dialogDetail" persistent max-width="800px">
            <v-card>
                <v-card-title>
                    <span class="title">Chi tiết sản phẩm</span>
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap pa-3>
                        <v-flex lg12 md12 sm12 xs12>
                            <v-text-field v-model="currentItem.product_code" label="Mã sản phẩm"
                                class="input-group--focused"></v-text-field>
                        </v-flex>
                        <v-flex lg12 md12 sm12 xs12>
                            <v-select v-model="currentItem.status" :items="statusOptions" label="Trạng thái"
                                class="input-group--focused" item-text="name" item-value="value"></v-select>
                        </v-flex>
                        <v-flex lg12 md12 sm12 xs12>
                            <v-select v-model="currentItem.staff_name" :items="staffConfigs" label="Người tạo"
                                class="input-group--focused" item-text="name" item-value="name"></v-select>
                        </v-flex>
                        <v-flex lg12 md12 sm12 xs12>
                            <v-textarea v-model="currentItem.madein" label="Thương hiệu" rows="3"
                                class="input-group--focused"></v-textarea>
                        </v-flex>
                        <v-flex lg12 md12 sm12 xs12>
                            <v-textarea v-model="currentItem.note" label="Ghi chú" rows="3"
                                class="input-group--focused"></v-textarea>
                        </v-flex>
                        <v-flex lg12 md12 sm12 xs12>
                            <v-textarea v-model="currentItem.propertices" label="Màu sắc" rows="3"
                                class="input-group--focused"></v-textarea>
                        </v-flex>
                        <v-flex lg2 md2 sm2 xs2>
                            <v-btn class="ma-2" color="indigo" dark @click="(dialogUpload = true)"><v-icon
                                    dark>upload</v-icon></v-btn>
                        </v-flex>
                        <v-flex lg12 md12 sm12 xs12 pt-2>
                            <v-layout row wrap class="images"  v-viewer="options">
                                <!-- Existing saved images -->
                                <div class="attach-image mr-4" v-for="(f, index) in currentItem.images" v-bind:key="'saved-' + f.id">
                                    <img style="width: 64px; height: 64px;" :src="f.path">
                                    <v-btn color="red" icon x-small @click="fileRemove(index)"><v-icon>fas fa-times-circle</v-icon></v-btn>
                                </div>
                                <!-- Preview images (not yet saved) -->
                                <div class="attach-image mr-4 preview-image" v-for="(preview, index) in previewImages" v-bind:key="'preview-' + index">
                                    <img style="width: 64px; height: 64px;" :src="preview.url" :alt="preview.name">
                                    <v-btn color="red" icon x-small @click="removePreviewImage(index)"><v-icon>fas fa-times-circle</v-icon></v-btn>
                                    <div class="preview-overlay">
                                        <v-icon small color="orange">visibility</v-icon>
                                    </div>
                                </div>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogDetail = false">Hủy</v-btn>
                    <v-btn color="blue darken-1" text @click="saveData">Đồng ý</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- Dialog cấu hình danh sách người tạo -->
        <v-dialog v-model="dialogStaffConfig" max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="title">Cấu hình danh sách người tạo</span>
                </v-card-title>
                <v-card-text>
                    <v-layout row wrap pa-3 class="align-center">
                        <v-flex lg8 md8 sm8 xs8>
                            <v-text-field v-model="staffConfigItem.name" label="Tên nhân viên"
                                @keyup.enter="saveStaffConfig" class="input-group--focused" hide-details></v-text-field>
                        </v-flex>
                        <v-flex lg4 md4 sm4 xs4 class="text-right">
                            <v-btn color="primary" @click="saveStaffConfig">
                                {{ staffConfigItem.id ? 'Cập nhật' : 'Thêm mới' }}
                            </v-btn>
                            <v-btn text v-if="staffConfigItem.id" @click="cancelEditStaff">Hủy</v-btn>
                        </v-flex>
                    </v-layout>
                    <v-divider class="my-3"></v-divider>
                    <v-list dense>
                        <template v-for="staff in staffConfigs">
                            <v-list-item :key="staff.id">
                                <v-list-item-content>
                                    <v-list-item-title>{{ staff.name }}</v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action style="flex-direction: row; min-width: 80px;">
                                    <v-btn icon small color="blue" @click="editStaffConfig(staff)">
                                        <v-icon small>edit</v-icon>
                                    </v-btn>
                                    <v-btn icon small color="red" @click="deleteStaffConfig(staff.id)">
                                        <v-icon small>delete</v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider :key="'div-' + staff.id"></v-divider>
                        </template>
                        <v-list-item v-if="staffConfigs.length === 0">
                            <v-list-item-content>
                                <v-list-item-title class="grey--text">Chưa có nhân viên nào được cấu hình</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="dialogStaffConfig = false">Đóng</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <upload-file :dialogUpload="dialogUpload" :file_types="'.png, .jpg, .jpeg'" title="Tải file hình ảnh" @closePopup="dialogUpload = false" @importFile="uploadFile"></upload-file>
    </v-container>
</template>

<script>
import Filtering from "@/components/Filtering";
import { mapState } from "vuex";
import configs from "@/configs";
import { sendErrorNotice } from "@/commons/utils";
import upload_file from "@/components/popups/upload_file";
import _ from "lodash";

export default {
    components: {
        "hpo-filter": Filtering,
        "upload-file": upload_file
    },
    data() {
        let dataType = configs.DATA_TYPE;
        return {
            options: {
                inline: false,
                button: true,
                navbar: true,
                title: 2,  // show if screen > 768px
                toolbar: {
                    zoomIn: 1,
                    zoomOut: 1,
                    oneToOne: 1,
                    reset: 1,
                    prev: 1,
                    play: {
                        show: 1,
                        size: 'large',
                    },
                    next: 1,
                    rotateLeft: 1,
                    rotateRight: 1,
                    flipHorizontal: 1,
                    flipVertical: 1,
                },
                tooltip: true,
                movable: true,
                zoomable: true,
                rotatable: true,
                scalable: true,
                transition: true,
                fullscreen: true,
                keyboard: true,
            },
            headers: [
                {
                    text: "Hình ảnh",
                    value: "first_image",
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Mã sản phẩm",
                    value: "product_code",
                    quickSearch: true,
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Trạng thái",
                    value: "status",
                    quickSearch: true,
                    filterable: true,
                    dataType: dataType["Enum"],
                    values: configs.PRODUCT_STATUS_LIST
                },
                {
                    text: "Thương hiệu",
                    value: "madein",
                    quickSearch: true,
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Ghi chú",
                    value: "note",
                    quickSearch: true,
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Màu sắc",
                    value: "propertices",
                    quickSearch: true,
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Người tạo",
                    value: "staff_name",
                    quickSearch: true,
                    filterable: true,
                    dataType: dataType["String"]
                },
                {
                    text: "Ngày tạo",
                    value: "created_date",
                    quickSearch: true,
                    filterable: true,
                    dataType: dataType["DateTime"]
                },
                {
                    text: "Thao tác",
                    value: "",
                    align: "center",
                    width: 100,
                    sortable: false,
                    filterable: false
                }
            ],
            pagination: { ...configs.PAGINATION, sortBy: ["id"] },
            items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
            viewName: this.$route.name || "product_list",
            filterConditions: [],
            quickFilterConditions: [],
            requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
            dialogDetail: false,
            dialogUpload: false,
            formData: null,
            statusOptions: configs.PRODUCT_STATUS_LIST,
            previewImages: [], // Store preview images before save
            dialogStaffConfig: false,
            staffConfigItem: { id: 0, name: "" }
        };
    },
    watch: {
        pagination: {
            handler: function (val, oldVal) {
                let filterConditions = this.$store.state.commons.filterConditions;
                this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
                this.filter_data();
            },
            deep: true
        },
        $route: {
            handler: function (to, from) {
                if (to.path !== from.path) {
                    this.viewName = to.name || "product_list";
                    this.pagination = { ...configs.PAGINATION, sortBy: ["id"] };
                    this.filterConditions = [];
                    this.quickFilterConditions = [];
                    this.filter_data();
                }
            }
        }
    },
    computed: {
        ...mapState({
            items: state => state.products.all.data,
            total_rows: state => state.products.all.total,
            loading: state => state.products.loading,
            currentItem: state => state.products.selected,
            staffConfigs: state => state.staffConfigs.all.data || []
        }),
        is_admin() {
            return this.$store.state.authentication.user.is_admin;
        },
    },
    methods: {
        filter_data: function () {
            var param = {
                pagination: this.pagination,
                filter: _.cloneDeep(this.filterConditions),
                quickFilter: this.quickFilterConditions
            };
            if (this.$route.meta.type) {
                param.filter.push({
                    column: "custom_type",
                    value: this.$route.meta.type,
                    condition: "s_equal"
                });
            }
            this.$store.dispatch("products/getList", param);
        },
        gotoDetail: function (id) {
            // let routeData = this.$router.resolve({
            //     name: "ProductDetail",
            //     params: {
            //         Pid: id,
            //         title: `Sản phẩm (#${id})`
            //     }
            // });
            // window.open(routeData.href, "_blank");
            this.$store.dispatch("products/getDetail", id);
            this.dialogDetail = true;
        },
        deleteItem: function (id) {
            window.getApp.$emit('REQUEST_DELETE_DATA', id);
        },
        applyFilter(filterConditions) {
            let sortBy = this.pagination.sortBy
            let sortDesc = this.pagination.sortDesc
            this.pagination = configs.PAGINATION;
            this.pagination.sortBy = sortBy;
            this.pagination.sortDesc = sortDesc;
            this.filterConditions = filterConditions;
            this.filter_data();
        },
        quickFilter(filterConditions) {
            this.quickFilterConditions = filterConditions;
            this.filter_data();
        },
        uploadFile(filelist) {
            this.formData = new FormData();
            this.previewImages = []; // Clear existing previews
            
            filelist.forEach((file) => {
                this.formData.append(`images[]`, file); // Tên tham số là "images"
                
                // Create preview for each file
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.previewImages.push({
                        url: e.target.result,
                        name: file.name,
                        file: file
                    });
                };
                reader.readAsDataURL(file);
            });
            this.dialogUpload = false;
        },
        fileRemove(index) {
            this.currentItem.images.splice(index, 1);
        },
        removePreviewImage(index) {
            // Remove from preview array
            this.previewImages.splice(index, 1);
            
            // Rebuild FormData without the removed file
            if (this.previewImages.length > 0) {
                this.formData = new FormData();
                this.previewImages.forEach((preview) => {
                    this.formData.append(`images[]`, preview.file);
                });
            } else {
                this.formData = null;
            }
        },
        saveData() {
            if(!this.is_admin) {
                sendErrorNotice('Bạn không có quyền chỉnh sửa & tạo mới sản phẩm');
                return;
            }
            this.$store.dispatch("products/setDetail", {
                data: {
                    ...this.currentItem,
                },
                id: this.currentItem.id
            }).then(p => {
                if (this.formData) {
                    this.formData.append('product_id', this.currentItem.id || p.data.id);
                    this.$store.dispatch("commons/upload_media_file", this.formData).then(() => {
                        // Clear preview images after successful upload
                        this.previewImages = [];
                        // Refresh current item to show newly uploaded images
                        this.$store.dispatch("products/getDetail", this.currentItem.id);
                        // Refresh the list to show updated images
                        this.filter_data();
                    });
                    this.formData = null;
                }
                this.dialogDetail = false;
            });
        },
        createData() {
            if (!this.is_admin) {
                sendErrorNotice('Bạn không có quyền tạo mới sản phẩm');
                return;
            }
            // this.$router.push({
            //     name: 'ProductDetail',
            //     params: {
            //         Pid: 'tao-moi',
            //         title: `Tạo mới sản phẩm`
            //     }
            // });
            this.$store.commit("products/setDetail", {
                data: {
                    id: 0
                }
            });
            this.dialogDetail = true;
        },
        display_value_color(value, options) {
            let option = options.find(o => o.value === value);
            return option ? option.textColor : 'inherit';
        },
        display_value_background_color(value, options) {
            let option = options.find(o => o.value === value);
            return option ? option.color : 'inherit';
        },
        refresh_all() {
            this.filter_data();
            this.$store.dispatch("staffConfigs/getList");
        },
        onConfigStaff() {
            if(!this.is_admin) {
                sendErrorNotice('Bạn không có quyền cấu hình người tạo');
                return;
            }
            this.dialogStaffConfig = true;
            this.staffConfigItem = { id: 0, name: "" };
            this.$store.dispatch("staffConfigs/getList");
        },
        saveStaffConfig() {
            if (!this.staffConfigItem.name || !this.staffConfigItem.name.trim()) {
                sendErrorNotice("Vui lòng nhập tên nhân viên");
                return;
            }
            this.$store.dispatch("staffConfigs/setDetail", {
                data: {
                    name: this.staffConfigItem.name.trim()
                },
                id: this.staffConfigItem.id
            }).then(() => {
                this.staffConfigItem = { id: 0, name: "" };
                this.$store.dispatch("staffConfigs/getList");
            });
        },
        editStaffConfig(staff) {
            this.staffConfigItem = { ...staff };
        },
        cancelEditStaff() {
            this.staffConfigItem = { id: 0, name: "" };
        },
        deleteStaffConfig(id) {
            if (confirm("Bạn có chắc chắn muốn xóa nhân viên này?")) {
                this.$store.dispatch("staffConfigs/removeDetail", id).then(() => {
                    this.$store.dispatch("staffConfigs/getList");
                });
            }
        }
    },
    mounted() {
        this.$root.$emit('REQUEST_ROOT_OPTION', {'invisibleOtherButton': !this.is_admin});
        this.$root.$on("REQUEST_CREATE_DATA", this.createData);
        this.$root.$on("REQUEST_REFRESH_DATA", this.refresh_all);
        this.$root.$on("REQUEST_OTHER_ACTION", this.onConfigStaff);
        this.$root.$on("CONFIRMED_REMOVE_DATA", id => {
            this.$store.dispatch("products/removeDetail", id);
        });
        this.$store.dispatch("staffConfigs/getList");
    },
    beforeDestroy() {
        this.$root.$off("REQUEST_CREATE_DATA", this.createData);
        this.$root.$off("REQUEST_REFRESH_DATA", this.refresh_all);
        this.$root.$off("REQUEST_OTHER_ACTION", this.onConfigStaff);
        this.$root.$off("CONFIRMED_REMOVE_DATA");
    }
};
</script>
<style type="text/css" scoped>
.attach-image {
    position: relative;
    width: 64px;
}

.attach-image button {
    position: absolute;
    right: 0;
    top: 0;
}

.attach-image .v-image {
    cursor: pointer;
}

.preview-image {
    border: 2px dashed #ff9800;
    border-radius: 4px;
    background-color: rgba(255, 152, 0, 0.1);
}

.preview-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    background-color: rgba(255, 152, 0, 0.8);
    color: white;
    padding: 2px 4px;
    border-radius: 0 4px 0 0;
    font-size: 10px;
}
</style>
